import { defineAsyncComponent } from 'vue';

import DefaultLayout from '@/layouts/DefaultLayout.vue';
import AuthLayout from '@/layouts/AuthLayout.vue';
import AuthLayoutRedesign from '@/layouts/AuthLayoutRedesign.vue';
import VIcon from '@/components/UI/iconComponents/VIcon.vue';
// import LocaleSwitcher from "@/components/UI/localeSwitcher/LocaleSwitcher.vue";
import ActionButton from '@/components/UI/buttons/ActionButton.vue';
import QButton from '@/components/UI/buttons/QButton.vue';
import QCheckbox from '@/components/UI/buttons/QCheckbox.vue';
import QToggle from '@/components/UI/buttons/QToggle.vue';
import QRadio from '@/components/UI/buttons/QRadio.vue';
import QRadioGroup from '@/components/UI/buttons/QRadioGroup.vue';
import QTextInput from '@/components/UI/inputs/QTextInput.vue';
import QSearch from '@/components/UI/inputs/QSearch.vue';
import QTextarea from '@/components/UI/inputs/QTextarea.vue';
import Datepicker from '@vuepic/vue-datepicker';
import SquareGrid from '@/components/UI/spinner/SquareGrid.vue';
import { Cropper } from 'vue-advanced-cropper';
import Vue3EasyDataTable from 'vue3-easy-data-table';
import CustomizeFooter from '@/components/UI/table/CustomizeFooter.vue';
import ErrorCheck from '@/components/UI/errors/Error.vue';
import ErrorCheckLogin from '@/components/UI/errors/ErrorLogin.vue';
import 'vue3-easy-data-table/dist/style.css';
import 'vue-advanced-cropper/dist/style.css';
// import "vue-advanced-cropper/dist/theme.compact.css";
import 'vue-advanced-cropper/dist/theme.classic.css';

const iconsComp = require.context('@/icons/', true, /\.vue$/);
const iconsTmpl = require.context('@/icons/package/', true, /\.vue$/);

export default function install(app) {
  app
    .component('DefaultLayout', DefaultLayout)
    .component('AuthLayout', AuthLayout)
    .component('AuthLayoutRedesign', AuthLayoutRedesign)
    .component('v-icon', VIcon)
    .component('action-button', ActionButton)
    .component('q-button', QButton)
    .component('q-checkbox', QCheckbox)
    .component('q-toggle', QToggle)
    .component('q-radio', QRadio)
    .component('q-radio-group', QRadioGroup)
    .component('q-text-input', QTextInput)
    .component('q-search', QSearch)
    .component('q-textarea', QTextarea)
    .component('EasyDataTable', Vue3EasyDataTable)
    .component('CustomizeFooter', CustomizeFooter)
    .component('ErrorCheck', ErrorCheck)
    .component('v-datepicker', Datepicker)
    .component('ErrorCheckLogin', ErrorCheckLogin)
    // .component("locale-switcher", LocaleSwitcher)
    .component('cropper', Cropper)
    .component('SquareGrid', SquareGrid);

  for (const comp of iconsComp.keys()) {
    const name = comp.replace(/^\.\//, '').replace(/\.\w+$/, '');
    app.component(
      `Icon${name}`,
      defineAsyncComponent(() => import('@/icons/' + name + '.vue')),
    );
  }
  for (const comp of iconsTmpl.keys()) {
    const name = comp.replace(/^\.\//, '').replace(/\.\w+$/, '');
    app.component(
      `Icon${name}`,
      defineAsyncComponent(() => import('@/icons/package/' + name + '.vue')),
    );
  }
}
